export default __webpack_public_path__ + "assets/images/ba3cf061dc9f0cd6a71693731f1fdd65.jpg";